import { SpotFile } from "@/types/spotflow";
import apiClient from "@/services/api-client";
import {
  buildPublicAuth,
  type PublicAuth,
} from "@/services/public/Conversation";

const uploadFile = (
  group_id: string,
  data: FormData,
  isPublic?: boolean
): Promise<SpotFile> => {
  return apiClient
    .post(
      `/api/backend/groups/${group_id}/file${isPublic ? "?is_public=true" : ""}`,
      data
    )
    .then((response) => response.data);
};

const getFile = (file_id: string): Promise<SpotFile> => {
  return apiClient
    .get(`/api/backend/file/${file_id.replace("spot://", "")}`)
    .then((response) => response.data);
};

const uploadFilePublic = (
  data: FormData,
  auth: PublicAuth
): Promise<SpotFile> => {
  const { query, headers } = buildPublicAuth(
    auth.token,
    auth.assistantId,
    auth.deploymentId,
    auth.authToken
  );
  return apiClient
    .post(`/api/public/groups/${auth.spotGroupId}/file/public?${query}`, data, {
      headers,
    })
    .then((response) => response.data);
};

const StorageService = {
  uploadFile,
  uploadFilePublic,
  getFile,
};

export { StorageService };
